import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import InvoicesComponent from "./WorkerAdminInvoicesComponent";
import PaymentComponent from "./WorkerAdminPaymentComponent";
import AdminSupportClaimsComponent from "./AdminSupportClaimsComponent";

const WorkerClaimsInvoicesBillingComponent = ({ user, toggleLeft }) => {
  const { tab } = useParams();

  const tabNames = {
    timesheets: "TimeSheets",
    invoices: "Invoices",
    payments: "Payments",
  };

  const tabComponents = {
    timesheets: <AdminSupportClaimsComponent user={user} />,
    invoices: <InvoicesComponent user={user} />,
    payments: <PaymentComponent user={user} />,
  };

  const [activeTab, setActiveTab] = useState(tab || "timesheets");
  useEffect(() => {
    toggleLeft();
    return () => {
      toggleLeft();
    };
  }, [toggleLeft]);

  useEffect(() => {
    setActiveTab(tab || "timesheets");
  }, [tab]);

  const handleTabClick = (key) => {
    setActiveTab(key);
  };

  return (
    <div className="post-jobs-container-admin">
      <div className="post-jobs-tabs-admin">
        <div className="tabs-group-admin">
          <div className="tabs-admin">
            {Object.entries(tabComponents).map(([key, component]) => (
              <div
                key={key}
                className={`tab ${activeTab === key ? "active" : ""}`}
                onClick={() => handleTabClick(key)}
              >
                {tabNames[key]}
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="post-job-tab-content-admin">
        {tabComponents[activeTab]}
      </div>
    </div>
  );
};

export default WorkerClaimsInvoicesBillingComponent;
